"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_META_DATA_BAD_DEFINITION = exports.ERROR_ACCOUNT_VALIDATION_FAILURE = exports.ERROR_ACCOUNT_PASSWORD_RESUSE = void 0;
exports.ERROR_ACCOUNT_PASSWORD_RESUSE = 'errors.com.epicgames.account.old_password_reuse';
exports.ERROR_ACCOUNT_VALIDATION_FAILURE = 'errors.com.epicgames.validation.validation_failed';
exports.ERROR_META_DATA_BAD_DEFINITION = 'errors.com.epicgames.account.auth_app.bad_definition_format';
//# sourceMappingURL=ServiceErrors.js.map